/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRadiusTopRight = createReactComponent("radius-top-right", "IconRadiusTopRight", [
  ["path", { d: "M5 5h6a8 8 0 0 1 8 8v6", key: "svg-0" }]
]);

export { IconRadiusTopRight as default };
//# sourceMappingURL=IconRadiusTopRight.js.map
